var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "relative rounded-lg overflow-hidden w-full pb-full",
      class: _vm.containerClasses,
    },
    [
      _c("CardImage", {
        staticClass: "block absolute top-0 left-0 w-full h-full",
        attrs: {
          src: _vm.avatar,
          givenName: _vm.givenName,
          userUpdatedDate: _vm.userUpdatedDate,
        },
      }),
      _c(
        "div",
        {
          staticClass:
            "flex flex-col justify-between p-3 absolute top-0 left-0 w-full h-full bg-transparent z-10",
        },
        [
          _c(
            "div",
            { staticClass: "flex justify-end" },
            [_vm._t("primary")],
            2
          ),
          _c("div", { staticClass: "flex justify-between items-end" }, [
            _c("div", [_vm._t("info")], 2),
            _c("div", [_vm._t("secondary")], 2),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }